/* Kuji-Kollektion (sections/kjxc-kuji-collection.liquid), Aufbau nach Snocks.
   Schnellfilter-Kacheln und das Auswahlfenster „Filter“ schreiben in denselben Zustand:
   status (''|new|low|out), price ('min-max' in Cent), serie, cheap (Kachel „Günstig starten“), sort.
   Laufende Karten werden im Browser sortiert und gefiltert, ausverkaufte kommen in Portionen
   aus dem <template>. ?serie=One%20Piece wählt eine Serie vor (Link von der Startseite). */
(function () {
  'use strict';

  function init(root) {
    if (root._kjxc) return;
    root._kjxc = true;

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
    var grid = $('[data-kjxc-grid]');
    var video = $('[data-kjxc-video]');
    var bar = $('[data-kjxc-bar]');
    var empty = $('[data-kjxc-empty]');
    var archive = $('[data-kjxc-archive]');
    var outGrid = $('[data-kjxc-out-grid]');
    var tpl = $('[data-kjxc-out-tpl]');
    var more = $('[data-kjxc-more]');
    var countEl = $('[data-kjxc-count]');
    var fn = $('[data-kjxc-fn]');
    var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 24;
    var cheapMax = parseInt(root.getAttribute('data-cheap'), 10) || 1600;
    var VIDEO_AFTER = 4;

    var items = [].slice.call(grid.querySelectorAll('.kjxc-item'));
    var outItems = null;
    var shown = 0;
    var state = { status: '', price: '', serie: '', cheap: false, sort: 'new' };

    function num(el, k) { return parseFloat(el.getAttribute('data-' + k)) || 0; }
    function priceOk(el) {
      var p = num(el, 'price');
      if (state.cheap && p > cheapMax) return false;
      if (!state.price) return true;
      var r = state.price.split('-');
      return p >= +r[0] && p <= +r[1];
    }
    function match(el, isOut) {
      if (state.serie && el.getAttribute('data-serie') !== state.serie) return false;
      if (!isOut && state.status === 'new' && el.getAttribute('data-new') !== '1') return false;
      if (!isOut && state.status === 'low' && el.getAttribute('data-low') !== '1') return false;
      return priceOk(el);
    }

    function renderLive() {
      var off = state.status === 'out';
      var list = items.slice().sort(function (a, b) {
        switch (state.sort) {
          case 'low': return num(a, 'pct') - num(b, 'pct') || num(b, 'pub') - num(a, 'pub');
          case 'price': return num(a, 'price') - num(b, 'price') || num(b, 'pub') - num(a, 'pub');
          case 'price-desc': return num(b, 'price') - num(a, 'price') || num(b, 'pub') - num(a, 'pub');
          default: return num(a, 'idx') - num(b, 'idx');
        }
      });
      var visible = 0;
      list.forEach(function (el) {
        var hide = off || !match(el, false);
        el.hidden = hide;
        grid.appendChild(el);
        if (!hide) {
          visible++;
          if (video && visible === VIDEO_AFTER) grid.appendChild(video);
        }
      });
      if (video) {
        if (visible < VIDEO_AFTER) grid.appendChild(video);
        video.hidden = visible === 0;
      }
      grid.hidden = off;
      if (empty) empty.hidden = off || visible > 0;
      return visible;
    }

    function renderOut(reset) {
      if (!archive) return 0;
      var on = state.status === 'out';
      archive.hidden = !on;
      if (!on) return 0;
      if (!outItems) {
        var frag = tpl && tpl.content ? tpl.content.cloneNode(true) : null;
        outItems = frag ? [].slice.call(frag.querySelectorAll('.kjxc-item')) : [];
      }
      var list = outItems.filter(function (el) { return match(el, true); });
      if (state.sort === 'price') list.sort(function (a, b) { return num(a, 'price') - num(b, 'price'); });
      if (state.sort === 'price-desc') list.sort(function (a, b) { return num(b, 'price') - num(a, 'price'); });
      if (reset) { outGrid.innerHTML = ''; shown = 0; }
      list.slice(shown, shown + pageSize).forEach(function (el) { outGrid.appendChild(el); });
      shown = Math.min(list.length, shown + pageSize);
      if (more) more.hidden = shown >= list.length;
      if (empty) empty.hidden = list.length > 0;
      return list.length;
    }

    function sync() {
      // Kacheln
      var quick = state.cheap ? 'cheap' : state.status;
      $$('[data-quick]').forEach(function (t) {
        var on = t.getAttribute('data-quick') === quick && !(quick === '' && (state.price || state.serie));
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      // Auswahlfenster
      $$('[data-group]').forEach(function (g) {
        var key = g.getAttribute('data-group');
        [].forEach.call(g.querySelectorAll('[data-v]'), function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-v') === String(state[key]) ? 'true' : 'false');
        });
      });
      var n = (state.status ? 1 : 0) + (state.price ? 1 : 0) + (state.serie ? 1 : 0) + (state.cheap ? 1 : 0);
      if (fn) { fn.hidden = !n; fn.textContent = n; }
    }

    function apply(resetOut) {
      var v = renderLive();
      var o = renderOut(resetOut !== false);
      if (countEl) {
        countEl.textContent = state.status === 'out' ? o + ' ausverkauft' : v + (v === 1 ? ' Set' : ' Sets') + ' live';
      }
      var go = $('[data-kjxc-go]');
      if (go) {
        var c = state.status === 'out' ? o : v;
        go.textContent = c ? c + (c === 1 ? ' Set' : ' Sets') + ' anzeigen' : 'Keine Treffer';
      }
      sync();
    }

    function reset() { state.status = ''; state.price = ''; state.serie = ''; state.cheap = false; apply(); }

    // Kacheln
    $$('[data-quick]').forEach(function (t) {
      t.addEventListener('click', function () {
        var q = t.getAttribute('data-quick');
        state.price = ''; state.serie = '';
        state.cheap = q === 'cheap';
        state.status = q === 'cheap' ? '' : q;
        apply();
        if (q === 'out' && archive) bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Auswahlfenster
    var lastFocus = null;
    function openSheet(name) {
      var s = $('[data-kjxc-sheet="' + name + '"]');
      if (!s) return;
      lastFocus = document.activeElement;
      s.hidden = false;
      document.documentElement.classList.add('kjxc-lock');
      var f = s.querySelector('[aria-pressed="true"]') || s.querySelector('button');
      if (f) f.focus({ preventScroll: true });
    }
    function closeSheets() {
      $$('[data-kjxc-sheet]').forEach(function (s) { s.hidden = true; });
      document.documentElement.classList.remove('kjxc-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    $$('[data-open]').forEach(function (b) { b.addEventListener('click', function () { openSheet(b.getAttribute('data-open')); }); });
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-group] [data-v]');
      if (opt) {
        var key = opt.closest('[data-group]').getAttribute('data-group');
        state[key] = opt.getAttribute('data-v');
        if (key === 'status' || key === 'price') state.cheap = false;
        apply();
        if (key === 'sort') closeSheets();
        return;
      }
      if (e.target.closest('[data-kjxc-reset]')) { reset(); return; }
      if (e.target.closest('[data-kjxc-show-out]')) { state.status = 'out'; apply(); return; }
      if (e.target.closest('[data-close]')) closeSheets();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheets(); });
    if (more) more.addEventListener('click', function () { renderOut(false); });

    // Leiste unter den (ein- und ausfahrenden) Theme-Header schieben
    var header = document.querySelector('sticky-header, .shopify-section-header-sticky, .section-header');
    function place() {
      var top = 0;
      if (header) {
        var r = header.getBoundingClientRect();
        var pos = getComputedStyle(header).position;
        if ((pos === 'sticky' || pos === 'fixed' || header.classList.contains('shopify-section-header-sticky')) && r.bottom > 0) top = Math.round(r.bottom);
      }
      root.style.setProperty('--kjxc-top', top + 'px');
      if (bar) bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= top + 1 && window.pageYOffset > 0);
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; place(); });
    }, { passive: true });
    window.addEventListener('resize', place);
    place();

    var pre = '';
    try { pre = new URLSearchParams(location.search).get('serie') || ''; } catch (e) {}
    if (pre && root.querySelector('[data-group="serie"] [data-v="' + (window.CSS && CSS.escape ? CSS.escape(pre) : pre) + '"]')) state.serie = pre;
    apply();
  }

  function boot() { document.querySelectorAll('[data-kjxc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
